import Alert from '@mui/material/Alert'
import * as React from 'react'

export function NoSelection() {
  return <Alert severity="info">No activity types selected</Alert>
}
